import { useState, useEffect } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export function useServiceImages(serviceName) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (!serviceName) return;

    setLoading(true);
    setError(null);

    // Opret en real-time listener
    const unsubscribe = onSnapshot(
      doc(db, 'services', serviceName),
      (doc) => {
        if (doc.exists()) {
          const imageData = doc.data().images || [];
          setImages(imageData);
        } else {
          setImages([]);
        }
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      }
    );

    // Cleanup listener
    return () => unsubscribe();
  }, [serviceName]);

  const handleNextImage = () => {
    if (images.length <= 1) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      setIsAnimating(false);
    }, 500);
  };

  const handlePrevImage = () => {
    if (images.length <= 1) return;
    setIsAnimating(true);
    setTimeout(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
      setIsAnimating(false);
    }, 500);
  };

  const handleImageChange = (index) => {
    setCurrentImageIndex(index);
  };

  return {
    images,
    loading,
    error,
    currentImageIndex,
    isAnimating,
    handleNextImage,
    handlePrevImage,
    handleImageChange
  };
} 